(function() {
    'use strict';

    var OUGoogleReviewModalCtrl = function ($scope, $http, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        var _this = this;
        var formdata = new FormData();

        $scope.ngModel = { message: { body: 'Some of your BUs have a different OU Google Review URL set. Are you sure you want to process?'}}

        if($scope.formModel === undefined) {
            $scope.formModel = passedModel;
        }

        $scope.ok = function() {
            document.querySelector("#review__consense").value = 'true';
            document.querySelector("form[name='primary']").submit();

            $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
        };

        $scope.cancel = function() {
            document.querySelector("#review__submit").disabled = false;
            $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close(this.ngModel);
        }

    };

    OUGoogleReviewModalCtrl.$inject = ['$scope','$http','ajaxCall','xmsNotificationFactory', '$uibModalInstance','params'];
    angular.module('app').controller('OUGoogleReviewModalCtrl',OUGoogleReviewModalCtrl);
}());